module.exports = __webpack_public_path__ + "assets/005fd9f62ce4f6cbfd92840246817209.mp3";